<template>
  <div v-if="checkin.instructions" class="alert" role="alert">
    <div>
      <button
        type="button"
        class="alert-guidance-btn"
        @click="showModal = true"
      >
        <i class="info_caution"></i>
        <h5 class="mgr40 fs14">チェックイン時の特記事項</h5>
        <p class="alert-guidance-details fwB">
          <i class="fa fa-chevron-circle-right fs16"></i>&nbsp;詳細はこちら
        </p>
      </button>
    </div>
    <tk-modal
      v-if="showModal"
      modal-size="lg"
      no-show-header
      :no-sp-fullscreen="true"
      style="padding-right: 0px;"
    >
      <h3 class="text-center pdt30">
        <strong>チェックイン時の特記事項</strong>
      </h3>
      <br />
      <br />
      <div class="row pdl40 pdr40 pdb30">
        <span style="font-size: 14px;">
          <strong>
            {{ checkin.instructions }}
            {{ checkin.special_instructions || '' }}
          </strong>
        </span>
      </div>
      <div class="Price_back2 pd10 width100Rest sp_dpb" style="clear: both;">
        <div class="row">
          <div class="w50p mglrauto">
            <p>
              <a class="btn btn-block btn-Green" @click="showModal = false">
                閉じる
              </a>
            </p>
          </div>
        </div>
      </div>
    </tk-modal>
  </div>
</template>

<script>
import TkModal from '../../atoms/TkGlobalModal/TkGlobalModal'

export default {
  name: 'TkHotelCheckinGuidance',
  components: { TkModal },
  props: {
    checkin: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return { showModal: false }
  },
}
</script>
